export enum PBReferrers {
  USER_ATTRIBUTES = 'user-attributes',
  IN_TRIAL = 'in-trial',
  MANAGE_PLANS = 'manage-plans',
  ASK_RESPONSE_LIMIT_PENDING = 'ask-response-limit-pending',
  ASK_RESPONSE_LIMIT_REACHED = 'ask-response-limit-reached',
  ASK_GRACE_PERIOD = 'ask-grace-period',
  INTEGRATIONS = 'integrations',
  SPECIFIC_INTEGRATION = 'specific-integration',
  SPACES = 'spaces',
  GENERIC = 'generic',
}

export enum PBBannerKinds {
  INFO = 'info',
  WARNING = 'warning',
}

export interface PBContext {
  referrer: PBReferrers;
  kind?: PBBannerKinds;
  i18nData?: {
    [key: string]: string | number;
  };
}
